import type { ControlType } from '@risksmart-app/domain/src/types/consts';

import type { AIWorkflowState } from '@/components/ai-workflows/aiWorkflowStore';
import { createAiWorkflowStore } from '@/components/ai-workflows/aiWorkflowStore';

export type JobStatus = 'processing' | 'completed' | 'failed' | 'queued';

export interface AISuggestedRiskControl {
  controlId: string;
  title: string;
  description: string;
  controlType: ControlType;
  confidenceScore: number;
  isLibraryMatch: boolean;
  createdByUser: string;
  createdAtTimestamp: string;
}

export interface AISuggestedRiskControlsLibraryMatching {
  matchedCount: number;
  totalCount: number;
}

export interface AISuggestedRiskControlsMetadata {
  libraryMatching: AISuggestedRiskControlsLibraryMatching;
}

export interface AISuggestedRiskControlsResult {
  suggestedControls: AISuggestedRiskControl[];
  metadata: AISuggestedRiskControlsMetadata;
}

export type AISuggestedRiskControlsState =
  AIWorkflowState<AISuggestedRiskControlsResult>;

export const useAISuggestedRiskControlsStore =
  createAiWorkflowStore<AISuggestedRiskControlsResult>();
